export default __webpack_public_path__ + "static/media/af6.41b04117.jpg";